import { api } from "@/utils/client";
import { keyBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        selected: undefined,
        showingDeleted: false
    },
    getters: {
        orderedList(state) {
                        return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        }
    },
    mutations: {
        setList(state, list) {
            state.ids = list.map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        addItem(state, {id, ...item}) {
            if (!state.ids.includes(id)) {
                state.ids = [id, ...state.ids];
                Vue.set(state.list, id, {id, ...item})
            }
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        setShowingDeleted(state, showingDeleted) {
            state.showingDeleted = showingDeleted;
        },
    },
    actions: {
        async getList({commit, state}, params = {}) {
            const {data: {data, meta}} = await api.get('/templates', {
                params: {
                    ...params,
                    deleted: state.showingDeleted ? 1 : 0
                }
            })
            commit('setList', data);
            commit('setMeta', meta);
            return data;
        },
        async getById({commit, rootState}, {id, ...params}) {
            const {data: {data}} = await api.get(`/templates/${id}`, {params})
            commit('addItem', data);
            if (data.pages) {
                commit('surveyTemplatePages/setList', data.pages, {root: true})
            }
            return data;
        },

        async getBySlug({commit}, slug) {
            const {data: {data}} = await api.get(`/templates/slug/${slug}`,)
            commit('addItem', data);
            return data;
        },
        async create({commit}, payload) {
            const {data: {data}} = await api.post('/templates', payload)
            commit('addItem', data);
            return data;
        },
        async update({commit}, {id, ...payload}) {
            const {data: {data}} = await api.put(`/templates/${id}`, payload)
            commit('updateItem', data);
            return data;
        },
        async publish({commit}, id) {
            const {data: {data}} = await api.put(`/templates/${id}/publish`)
            commit('updateItem', data);
            return data;
        },
        async unpublish({commit}, id) {
            const {data: {data}} = await api.put(`/templates/${id}/unpublish`)
            commit('updateItem', data);
            return data;
        },
        async delete({commit}, id) {
            await api.delete(`/templates/${id}`)
            commit('removeItem', id);
        },
        async restore({commit}, id) {
            const {data: {data}} = await api.put(`/templates/${id}/restore`)
            commit('updateItem', data);
            return data;
        },
        async forceDelete({commit}, id) {
            const {data: {data}} = await api.delete(`/templates/${id}`, {data: {permanent: true}})
            commit('removeItem', id);
            return data;
        },
        async activate({commit, state, rootState}, payload) {
            payload.team_id = rootState.teamId;
            const {data: {data}} = await api.post(`/templates/${state.selected}/activate`, payload)
            commit('surveys/addItem', data, {root: true});
            return data;
        },
        async reorder({commit, state, getters}, ids) {
            commit('setList', ids.map((id, index) => ({
                ...state.list[id],
                order: index + 1
            })))

            const payload = getters.orderedList.map(({id, order}) => ({id, order}));
            const {data: {data}} = await api.patch('templates', payload)
            commit('setList', data);
        },
    }

}
